import { AxiosClient, AxiosToken } from '../config/axios'

/**
 * This method is used to connect with backend and get payu data
 * @return {IPayU} IPayU
*/
export const getDataPayU = async (): Promise<any> => {
  try
  {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get(`/payu`)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.res.data.message }
  }
}